(ns common.schema.entities.call
  (:require [common.schema.entities.related-entities :as related-entities]
            [common.schema.entities.activity :as activity]))

(defonce import-fixed-fields [:note-call/message])

(def new-call
  (concat [[:note-call/message {
                                :field/data-type             :data.type/text-richtext
                                :field/default-authorization {:access/read  :role/guest-buy-side
                                                              :access/write :role/guest-buy-side}
                                :field/default-visibility    {:editor :editor.type/none
                                                              :grid   :editor.type/none
                                                              :filter :filter.type/text
                                                              :field-visibility :in-use}
                                :field/translations          {:en "Message"}}]
           [:note-call/type {:field/data-type             :data.type/keyword
                             :field/default-authorization {:access/read  :role/guest-buy-side
                                                           :access/write :role/guest-buy-side}
                             :field/default-visibility    {:editor :editor.type/radio
                                                           :grid   :editor.type/checkbox
                                                           :filter :filter.type/select
                                                           :field-visibility :in-use}
                             :value-type                  :keyword
                             :options                     [{:key   :outbound
                                                            :label "Outbound"}
                                                           {:key   :inbound
                                                            :label "Inbound"}]
                             :field/translations          {:en "Type"}}]
           [:note-call/call-made-by {:field/data-type             :data.type/ref-single
                                     :field/default-authorization {:access/read  :role/guest-buy-side
                                                                   :access/write :role/guest-buy-side}
                                     :field/default-visibility    {:editor :editor.type/select
                                                                   :grid   :editor.type/select
                                                                   :filter :filter.type/select
                                                                   :field-visibility :in-use}
                                     :field/entity-types          [:entity.type/account]
                                     :field/not-clearable?        true
                                     :field/translations          {:en "Made by"}
                                     :value-type                  :entity
                                     :field/in-use-for-this-data? (fn [entity entity-types-lookup has-feature-access-fn has-entity-access?]
                                                                    (not= :inbound (:note-call/type entity)))}]
           [:note-call/timestamp {
                                  :field/data-type             :data.type/date
                                  :field/default-authorization {:access/read  :role/guest-buy-side
                                                                :access/write :role/guest-buy-side}
                                  :field/default-visibility    {:editor :editor.type/date
                                                                :grid   :editor.type/date
                                                                :filter :filter.type/date
                                                                :field-visibility :in-use}
                                  :field/translations          {:en "Date"}}]]
          activity/new-activity
          related-entities/related-entities))
